import React, { useState } from "react";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import AccountPage from "../features/account/AccountPage";
import "../features/account/account.scss";

const Account = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="account-container">
      <Sidebar className={isSidebarOpen ? "open" : ""} />
      {isSidebarOpen && (
        <div className="overlay" onClick={() => setIsSidebarOpen(false)} />
      )}

      <div className="account-content">
        <Header onMenuClick={() => setIsSidebarOpen((p) => !p)} />
        <AccountPage />
      </div>
    </div>
  );
};

export default Account;
